import { render, staticRenderFns } from "./TypeVehicleModal.vue?vue&type=template&id=dfba1694&"
import script from "./TypeVehicleModal.vue?vue&type=script&lang=js&"
export * from "./TypeVehicleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports